<template>
    <div class="containerInner">
        <div class="listHeader">
            <div class="headerLeftMenu">
                <span>広告アカウント設定</span>
                <span>
                    <select v-model="searchId" class="searchInputText">
                        <option value="">サービス名</option>
                        <option v-for="service in services" :value="service.id" v-bind:key="service.id">{{ service.name
                            }}</option>
                    </select>
                </span>
                <span>
                    <a class="btn searchBtn" @click="searchAccount">検索</a>
                </span>
                <span v-if="this.account.length === 0">
                    対象のサービスに紐づくアカウントがありません。
                </span>
            </div>
            <div class="headerRightMenu">
                <Button @click="openCreateModal">新規追加</Button>
            </div>
        </div>

        <ul class="list">
            <template v-for="ac in this.account">
                <li class="info" v-bind:key="ac.id">
                    <div class="infoLeft">
                        <h3><span>【{{ ac.id }}】</span>{{ ac.account_name }}</h3>
                        <p>アカウントID : {{ ac.account_id }}</p>
                        <p>サービス名 : {{ ac.service_name }}</p>
                        <p>広告媒体名 : {{ ac.media_name }}</p>
                        <p>備考 : {{ ac.memo }}</p>
                    </div>
                    <div class="infoRight">
                        <Button class="btn" @click="openUpdateModal(ac.id)">編集</Button>
                    </div>
                </li>
            </template>
        </ul>

        <div class="listFooter">
        </div>
        <modal name="adAccountModal" :draggable="false" :resizable="false" width="80%" height="90%">
            <AdAccountModal :accountId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('adAccountModal')" />
        </modal>
        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <p>{{ this.statusMessage }}</p>
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>
import AdAccountModal from '../components/AdAccountModal.vue';

export default {
    components: {
        AdAccountModal,
    },
    data() {
        return {
            statusMessage: "",
            account: {},
            selectedId: null,
            createMode: true,
            services: {},
            searchId: "",
        }
    },
    mounted: function () {
        this.getAccounts();
        this.getServiceId();
    },
    methods: {
        //登録済みアカウントの一覧取得
        getAccounts: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/adAccount")
                .then((res) => {
                    this.account = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //サービスIDの一覧取得
        getServiceId: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/service/")
                .then((res) => {
                    this.services = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //検索
        searchAccount: function () {
            this.$store.dispatch("loading", true);

            let url = '';

            //初期値が選択されている場合、全件取得
            if (this.searchId === "") {
                url = "/api/adAccount";
            }

            //各サービス名が選択されている場合、対象のサービスに紐づくアカウントのみ取得
            else {
                url = "/api/adAccount/service/" + this.searchId;
            }

            this.axios.get(url)
                .then((res) => {
                    this.account = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //追加
        openCreateModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('adAccountModal');
        },

        //更新
        openUpdateModal: function (id) {
            this.selectedId = id;
            this.createMode = false;
            this.$modal.show('adAccountModal');
        },

        //データを再取得してモーダルを閉じる
        modalClosed(modalName) {
            this.getAccounts();
            this.$store.dispatch("loading", false)
            this.$store.dispatch("successful", false)
            this.$modal.hide(modalName)
        },

    },
}
</script>

<style scoped lang="sass">
.containerInner
    display: inline-grid
    .listHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 100%
            span
                display: inline-block
                vertical-align: middle
                .searchInputText
                    margin-left: 20px
                    padding: 10px
                    width: 360px
                    &:focus
                        outline: 2px solid $mainColor
                .searchBtn
                    border: 1px solid $mainColor
                    margin: 0 20px 0 10px
                    padding: 12px
                    width: 60px
                    &:hover
                        border: 1px solid $mainColor
    .list
        background: $whiteColor
        font-size: 1.2rem
        margin: 10px 140px 0 140px
        overflow-y: scroll
        height: 750px
        .info
            border-bottom: 3px solid #f8f8ff
            color: $grayColor
            display: flex
            justify-content: space-between
            padding: 10px
            .btn
                width: 100px
                margin-left: 20px
                margin-bottom: 8px
            .infoLeft
                display: flex
                flex-direction: column
                justify-content: center
                h3
                    font-size: 1.5rem
                    font-weight: 700
                    margin-bottom: 10px
                p
                    margin: 0 0 10px 20px
                    font-size: 1.4rem
                    display: flex
                .name
                    font-weight: 700
                .description
                    margin-left: 16px
                .inputText
                    margin-left: 10px
                    padding: 10px
                    width: 200px
                    &:focus
                        outline: 2px solid $mainColor
            .infoRight
                margin-right: 30px
                display: flex
                flex-direction: column
                justify-content: center
                padding: 10px 0
    .listFooter
        margin: 20px 140px 0 140px
        position: relative
        display: flex
        justify-content: center
        .updateBtn
            width: 80px

    .loadingWindow
        overflow: hidden
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
@include sp()
    .containerInner
        .listHeader
            display: block
            margin: 0 0 0 10px
            .headerLeftMenu
                .searchInputText
                    width: 150px !important
        .list
            margin: 10px 0 0
</style>